module.exports = __webpack_public_path__ + "src/assets/img/zh.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zh.svg
// module id = 9CtL
// module chunks = 80